import React from 'react'
import './styles/Return.css';

export default function Return() {
    return (
        <div className="success-container">
            <div className="success-card">
                <div className="success-icon">&#10004;</div>
                <h1>Welcome to the Party! 🎉</h1>
                <p>Your payment went through without a hitch. We're doing a happy dance on your behalf!</p>
                <p className="email-message">
                    An email is on the way with your tickets.
                </p>
                <button className="continue-button" onClick={() => window.location.href = '/'}>
                    Let's Go
                </button>
            </div>
        </div>
    )
}
